module.exports = __webpack_public_path__ + "img/background-modal.8a0c1d46.png";